module.exports = __webpack_public_path__ + "static/media/warningIcon.72ca513d.svg";